/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XLargeBoldIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1ElEQVR4nN2VSQ7CMAxFY8S9coLYYdMG6KaIe+QWsAGuCjIUqeoQnKFIECmr+L/fOrGt1N8srfUarTvgptorpSABAaxlBrNGp0TbI1p37/bFe7+SkjmWNW89s0ZBxrqmZyA28QP4c7+yIAi0YZMUDSC5U19gqL7OCGJiPwituw2EYKg+p8AlJpALD+YXI3Me/SeY++VSE1MIrqZyPnPx5eBYwmTpS4bAUwRBnYThggqFclVMhVrF4s3OFGzXxrrm+wNH88jEqiWqd1kjE6t2cmT+7HoA36JpZuSIRPEAAAAASUVORK5CYII=)
 */
export const XLargeBoldIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.94 21.06a1.5 1.5 0 1 0 2.12-2.12L14.12 12l6.94-6.94a1.5 1.5 0 1 0-2.12-2.12L12 9.88 5.06 2.94a1.5 1.5 0 1 0-2.12 2.12L9.88 12l-6.94 6.94a1.5 1.5 0 1 0 2.12 2.12L12 14.12l6.94 6.94Z"
        className={colorClass}
      />
    </svg>
  );
};
